import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },

    header: {
      padding: 12,

      '& .MuiTypography-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,

        '& svg': {
          width: 14,
          height: 14,
        },
      },
    },

    content: {
      flex: 1,
      padding: 12,
      overflow: 'hidden',
    },
    contentInCreation: {
      display: 'flex',
      alignItems: 'center',
    },

    contentFields: {
      flexWrap: 'nowrap',
    },

    fieldset: {
      gap: '8px',
      '& .MuiFormControlLabel-root': {
        marginLeft: 1,
      },
      marginBottom: 8,
    },
    madeByText: { fontSize: 12, display: 'flex', gap: '4px' },
    alert: {
      width: 'fit-content',
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    alertText: { fontSize: 12 },
    madeByGrid: { margin: '8px 0' },
    reasonField: {
      '& .MuiOutlinedInput-root': { height: 'auto' },
      '& .MuiOutlinedInput-multiline': { padding: 14 },
    },
  });
